export default __webpack_public_path__ + "static/media/bug-example.b5bd10ab.png";